module.exports = __webpack_public_path__ + "static/img/autumn_banner.f9a015ef.jpg";